import React from 'react';

const buildResults = (results) =>
  results.map(({ fullAddress }) => ({
    value: fullAddress,
    label: <span>{fullAddress}</span>,
  }));

export default buildResults;
